import React, { useEffect, useState } from "react";
import { LuArrowLeft, LuMail} from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
import { StatefulButton } from "../ui/button";
import { validateEmail } from "../../utils/helpers";
import "../Login/login.css";
import "./forgot-password.css";

const loginLogo = "https://app.groupboss.io/static/media/logo.d96bc6c1f4b02f704ac1.png"

const ForgotPassword = ({ forgotPassword, forgot = {} }) => {
  const [email, setEmail] = useState("");
  const [fieldError, setFieldError] = useState("");
  const [feedback, setFeedback] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("access_token") !== null) {
      navigate("/user/dashboard");
    }
  }, [navigate]);

  useEffect(() => {
    if (forgot.successMessage) {
      setFeedback({ type: "success", message: forgot.successMessage });
    } else if (forgot.errorMessage) {
      setFeedback({ type: "error", message: forgot.errorMessage });
    }
  }, [forgot.errorMessage, forgot.successMessage]);

  const onTextChange = (event) => {
    setEmail(event.target.value);
    setFieldError("");
    setFeedback(null);
  };

  const openSupport = (event) => {
    event.preventDefault();

    if (window.anw2 && typeof window.anw2.open === "function") {
      window.anw2.open();
    } else {
      document.getElementById("anw2-launcher-button-GEHlG5d1azeJzDWtf5WkgQ")?.click();
    }
  };

  const handleForgotPassword = (event) => {
    event.preventDefault();

    const normalizedEmail = email.trim();

    if (!normalizedEmail) {
      setFieldError("Email address can't be empty");
      setFeedback(null);
      return;
    }

    if (!validateEmail(normalizedEmail)) {
      setFieldError("Please insert a valid email address");
      setFeedback(null);
      return;
    }

    setFieldError("");
    setFeedback(null);
    forgotPassword({ email: normalizedEmail });
  };

  return (
    <main className="login-page forgot-password-page">
      <div className="login-shell forgot-password-shell">
        <section className="login-main forgot-password-main" aria-labelledby="forgot-password-title">
          <div className="forgot-password-content">
            <a className="login-brand" href="https://groupboss.io" aria-label="Groupboss home">
            <img loading="lazy" src={loginLogo} alt="Groupboss" />
          </a>

            <h1 id="forgot-password-title">Forgot your password?</h1>
            <p className="forgot-password-description">
              No worries! Enter your email and we'll send you a reset link
            </p>

            <form className="login-form forgot-password-form" onSubmit={handleForgotPassword} noValidate>
              <div className="login-fields">
                <div className={`login-field${fieldError || feedback?.type === "error" ? " login-field--error" : feedback?.type === "success" ? " forgot-password-field--success" : ""}`}>
                  <label htmlFor="forgot-password-email">Email address</label>
                  <div className="login-input-wrap forgot-password-input-wrap">
                    <LuMail className="forgot-password-input-icon" aria-hidden="true" size={18} strokeWidth={1.6} />
                    <input
                      className="login-input"
                      id="forgot-password-email"
                      name="email"
                      type="email"
                      maxLength="255"
                      autoComplete="email"
                      value={email}
                      onChange={onTextChange}
                      aria-invalid={Boolean(fieldError)}
                      aria-describedby={fieldError ? "forgot-password-email-error" : feedback ? "forgot-password-email-feedback" : undefined}
                    />
                  </div>
                  {fieldError && (
                    <span className="login-field__error" id="forgot-password-email-error" role="alert">
                      {fieldError}
                    </span>
                  )}
                  {!fieldError && feedback && (
                    <span
                      className={feedback.type === "success" ? "forgot-password-field__success" : "login-field__error"}
                      id="forgot-password-email-feedback"
                      role="alert"
                      aria-live="polite"
                    >
                      {feedback.message}
                    </span>
                  )}
                </div>
              </div>

              <div className="login-actions forgot-password-actions">
                <StatefulButton
                  className="login-button forgot-password-submit"
                  type="submit"
                  loadingText="Sending..."
                  state={forgot.isLoading ? "loading" : feedback?.type || "idle"}
                >
                  Send reset link
                </StatefulButton>
              </div>
            </form>

            <Link className="login-secondary-link forgot-password-back" to="/login">
              <LuArrowLeft aria-hidden="true" size={18} strokeWidth={1.8} />
              <span>Back to sign in</span>
            </Link>

            <aside className="forgot-password-help" aria-label="Support">
              <h2>Need help?</h2>
              <p>If you're still having trouble, contact our support team for assistance.</p>
              <a href="#support" onClick={openSupport}>
                Contact support
              </a>
            </aside>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ForgotPassword;
